var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.924 9.75284L10.4652 9.04387C9.67285 7.87616 9.25581 6.49992 9.25581 5.08198C9.25581 3.58063 8.25491 2.37122 6.92038 1.95417C6.79527 1.57884 6.41993 1.32861 6.00289 1.32861C5.58585 1.32861 5.21051 1.57884 5.0854 1.95417C3.75087 2.37122 2.74997 3.58063 2.74997 5.08198C2.74997 6.49992 2.33293 7.87616 1.54055 9.04387L1.0818 9.75284C0.873283 10.0865 1.0818 10.5035 1.49884 10.5035H10.5069C10.924 10.5035 11.1325 10.0865 10.924 9.75284Z",
    fill: "#797797",
    stroke: "#787696",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67104 10.5034C7.67104 11.4209 6.92037 12.1716 6.00288 12.1716C5.08539 12.1716 4.33472 11.4209 4.33472 10.5034",
    fill: "#797797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67104 10.5034C7.67104 11.4209 6.92037 12.1716 6.00288 12.1716C5.08539 12.1716 4.33472 11.4209 4.33472 10.5034",
    stroke: "#787696",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_101_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292897 11.0855C-0.0976325 11.476 -0.0976325 12.1092 0.292897 12.4997C0.683427 12.8903 1.31659 12.8903 1.70711 12.4997L11.49 2.7071M0.292897 11.0855L0.646447 11.4391ZM0.292897 11.0855L0.646447 11.4391ZM0.292897 11.0855L10.0757 1.29306C10.4663 0.902553 11.0995 0.902373 11.49 1.29288C11.8806 1.6834 11.8806 2.31658 11.49 2.7071M0.646447 11.4391C0.451187 11.6343 0.451187 11.9509 0.646447 12.1462C0.841707 12.3414 1.1583 12.3414 1.35356 12.1462L0.646447 11.4391Z",
    fill: "#797797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.292897 11.0855C-0.0976325 11.476 -0.0976325 12.1092 0.292897 12.4997C0.683427 12.8903 1.31659 12.8903 1.70711 12.4997L11.49 2.7071M0.292897 11.0855L0.646447 11.4391M0.292897 11.0855L10.0757 1.29306C10.4663 0.902553 11.0995 0.902373 11.49 1.29288M11.49 2.7071C11.8806 2.31658 11.8806 1.6834 11.49 1.29288M11.49 2.7071L11.1365 2.35355M0.646447 11.4391C0.451187 11.6343 0.451187 11.9509 0.646447 12.1462C0.841707 12.3414 1.1583 12.3414 1.35356 12.1462L0.646447 11.4391ZM11.49 1.29288L11.1394 1.64352",
    stroke: "#EAEEF6",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_101_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationIcon);
export default __webpack_public_path__ + "static/media/NoNotificationIcon.c55d34611152b9478508aa1c0e4fa9b2.svg";
export { ForwardRef as ReactComponent };